module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('lottie', {
    attrs: {
      "options": _vm.defaultOptions,
      "height": 400,
      "width": 400
    },
    on: {
      "animCreated": _vm.handleAnimation
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v("Speed: x" + _vm._s(_vm.animationSpeed))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.animationSpeed),
      expression: "animationSpeed"
    }],
    attrs: {
      "type": "range",
      "value": "1",
      "min": "0",
      "max": "3",
      "step": "0.5"
    },
    domProps: {
      "value": (_vm.animationSpeed)
    },
    on: {
      "change": _vm.onSpeedChange,
      "__r": function($event) {
        _vm.animationSpeed = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("stop")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.pause
    }
  }, [_vm._v("pause")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.play
    }
  }, [_vm._v("play")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b31fb8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 15
// module chunks = 0